import { render } from "./News.vue?vue&type=template&id=7faf0365&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=7faf0365&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src407580977/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faf0365"]])

export default __exports__